import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const GASTOS_CATS = ['GMF', '4X1000', 'COMISION', 'CUOTA MANEJO', 'INTERESES', 'IVA', 'COBRO BANCARIO', 'GASTO FINANCIERO', 'RETENCION'];
const TIPO_ORDER = ['consig_no_libros', 'nd_no_libros', 'consig_no_extracto', 'cheques_pendientes'];
const TIPO_LABELS = {
  consig_no_libros:   'Consig. / NC no en libros',
  nd_no_libros:       'ND / Gastos no en libros',
  consig_no_extracto: 'Consig. / NC no en extracto',
  cheques_pendientes: 'Cheques / Créditos pendientes',
};
const auxGetCategory = (r, headers, cfgObj) => {
  const hD = (headers || [])[(parseInt((cfgObj || {}).col_debito_auxiliar || '7') - 1)];
  const hC = (headers || [])[(parseInt((cfgObj || {}).col_credito_auxiliar || '8') - 1)];
  const d = hD ? parseFloat((r[hD] || '0').toString().replace(/[^0-9.-]/g, '')) || 0 : 0;
  const c = hC ? parseFloat((r[hC] || '0').toString().replace(/[^0-9.-]/g, '')) || 0 : 0;
  return (c > 0 && c >= d) ? 'cheques_pendientes' : 'consig_no_extracto';
};

// NOTA: este es el ÚNICO Historial que usa la app (lo importa App.js desde
// './pages/Historial'). El archivo antiguo src/Historial.js era una copia vieja
// sin botón de descarga y se eliminó.
//
// CAMBIO: se agregó el botón "PDF" junto al de "Excel" para descargar el reporte
// formal en PDF usando el endpoint /conciliaciones/{id}/reporte-pdf del backend.

export default function Historial() {
  const { API, user, logout } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busqueda, setBusqueda] = useState('');
  const [descargando, setDescargando] = useState(null);

  // ── Modal de cruce manual ──
  const [modal, setModal] = useState(null);
  // modal = { conc, resultado, cfg, partidas, cruces, selBanco, selAux, cargando, descargando }

  const tiposPartida = {
    'consig_no_libros': 'Consig./NC no en libros',
    'nd_no_libros': 'ND/Cheques no en libros',
    'consig_no_extracto': 'Consig. no en extracto',
    'cheques_pendientes': 'Cheques pendientes'
  };

  const abrirCruces = async (conc) => {
    setModal({ conc, resultado: null, cfg: null, cruces: [], selBanco: null, selAux: null, selAux2: null,
               cargando: true, descargando: null, error: null,
               saldoExtracto: '', saldoLibros: '',
               partidas: [], nuevaPartida: { tipo: 'consig_no_libros', fecha: '', documento: '', descripcion: '', valor: '', observacion: '' },
               tab: 'cruces' });
    try {
      const r = await axios.get(`${API}/conciliaciones/${conc.id}/resultado`);
      const { resultado, cfg, partidas } = r.data;
      setModal(prev => ({
        ...prev, resultado, cfg, cargando: false,
        saldoExtracto: String(cfg.saldo_extracto || ''),
        saldoLibros: String(cfg.saldo_libros || ''),
        partidas: partidas.map(p => ({ tipo: p.tipo, fecha: p.fecha || '', documento: p.documento || '', descripcion: p.descripcion || '', valor: p.valor || 0, observacion: p.observacion || '' }))
      }));
    } catch {
      setModal(prev => ({ ...prev, cargando: false, error: 'No se pudo cargar la conciliación.' }));
    }
  };

  const reprocesar = async () => {
    if (!modal) return;
    setModal(prev => ({ ...prev, reprocesando: true, errorRepro: null }));
    try {
      const fd = new FormData();
      if (modal.nuevoExtracto) fd.append('extracto', modal.nuevoExtracto);
      if (modal.nuevoAuxiliar) fd.append('auxiliar', modal.nuevoAuxiliar);
      const r = await axios.post(`${API}/conciliaciones/${modal.conc.id}/reprocesar`, fd);
      // Recargar resultado con el nuevo
      setModal(prev => ({
        ...prev, reprocesando: false,
        resultado: r.data,
        nuevoExtracto: null, nuevoAuxiliar: null,
        cruces: [], selBanco: null, selAux: null, selAux2: null,
        tab: 'cruces'
      }));
    } catch (e) {
      setModal(prev => ({ ...prev, reprocesando: false, errorRepro: e.response?.data?.detail || 'Error al reprocesar.' }));
    }
  };

  const cruzarModal = async () => {
    if (modal.selBanco === null || modal.selAux === null) return;

    const isGroup = typeof modal.selBanco === 'string' && modal.selBanco.startsWith('grp_');
    let indices;
    if (isGroup) {
      const catKey = modal.selBanco.replace('grp_', '');
      const gastos = {};
      modal.resultado.banco.forEach((r, i) => {
        if (r._cruza || !r._gasto_bancario) return;
        const det = (r['DETALLE'] || '').toString().toUpperCase();
        const cat = GASTOS_CATS.find(c => det.includes(c)) || 'GASTO BANCARIO';
        if (!gastos[cat]) gastos[cat] = [];
        gastos[cat].push(i);
      });
      indices = gastos[catKey] || [];
    } else {
      indices = [modal.selBanco];
    }

    const isPartida = typeof modal.selAux === 'string' && modal.selAux.startsWith('part_');
    const partidaIdx = isPartida ? parseInt(modal.selAux.replace('part_', '')) : null;

    const banco = modal.resultado.banco.map((r, i) => indices.includes(i) ? { ...r, _cruza: true } : r);
    const auxiliar = isPartida
      ? modal.resultado.auxiliar
      : modal.resultado.auxiliar.map((r, i) => i === modal.selAux ? { ...r, _cruza: true } : r);
    const cruzan = banco.filter(r => r._cruza).length;
    const newCruces = isPartida
      ? [...modal.cruces, ...indices.map(bi => ({ banco_idx: bi }))]
      : [...modal.cruces, ...indices.map(bi => ({ banco_idx: bi, aux_idx: modal.selAux }))];
    const newPartidas = isPartida
      ? modal.partidas.filter((_, i) => i !== partidaIdx)
      : modal.partidas;

    setModal(prev => ({
      ...prev,
      selBanco: null, selAux: null, selAux2: null,
      cruces: newCruces,
      partidas: newPartidas,
      resultado: {
        ...prev.resultado, banco, auxiliar, cruzan,
        no_cruzan_banco: banco.filter(r => !r._cruza).length,
        no_cruzan_aux: auxiliar.filter(r => !r._cruza).length,
        porcentaje_conciliacion: banco.length > 0 ? Math.round(cruzan / banco.length * 1000) / 10 : 0
      }
    }));

    // Guardar inmediatamente para que los cambios persistan aunque no se descargue
    try {
      const fd = new FormData();
      fd.append('cruces_manuales_json', JSON.stringify(newCruces));
      fd.append('partidas_json', JSON.stringify(newPartidas));
      await axios.post(`${API}/conciliaciones/${modal.conc.id}/sync-partidas`, fd);
    } catch {
      // Silencioso: se volverá a guardar al descargar
    }
  };

  // Cruce dentro del mismo auxiliar: débito ↔ crédito que se cancelan entre sí
  const cruzarAuxAux = async () => {
    if (modal.selAux === null || modal.selAux2 === null) return;
    const i1 = modal.selAux, i2 = modal.selAux2;
    const auxiliar = modal.resultado.auxiliar.map((r, i) =>
      (i === i1 || i === i2) ? { ...r, _cruza: true } : r
    );
    const cruzan = modal.resultado.banco.filter(r => r._cruza).length;
    const newCruces = [...modal.cruces, { aux_idx: i1 }, { aux_idx: i2 }];

    setModal(prev => ({
      ...prev,
      selAux: null, selAux2: null,
      cruces: newCruces,
      resultado: {
        ...prev.resultado, auxiliar, cruzan,
        no_cruzan_aux: auxiliar.filter(r => !r._cruza).length,
      }
    }));

    try {
      const fd = new FormData();
      fd.append('cruces_manuales_json', JSON.stringify(newCruces));
      fd.append('partidas_json', JSON.stringify(modal.partidas));
      await axios.post(`${API}/conciliaciones/${modal.conc.id}/sync-partidas`, fd);
    } catch {}
  };

  const descargarDesdeModal = async (formato) => {
    setModal(prev => ({ ...prev, descargando: formato }));
    try {
      // Guardar explícitamente antes de generar el reporte
      const fdSync = new FormData();
      fdSync.append('cruces_manuales_json', JSON.stringify(modal.cruces));
      fdSync.append('partidas_json', JSON.stringify(modal.partidas));
      await axios.post(`${API}/conciliaciones/${modal.conc.id}/sync-partidas`, fdSync);

      // Generar reporte (los cruces ya quedaron en resultado_json por sync-partidas)
      const fd = new FormData();
      fd.append('cruces_manuales_json', JSON.stringify(modal.cruces));
      fd.append('partidas_json', JSON.stringify(modal.partidas));
      fd.append('saldo_extracto', modal.saldoExtracto || '0');
      fd.append('saldo_libros', modal.saldoLibros || '0');
      fd.append('formato', formato);
      const r = await axios.post(`${API}/conciliaciones/${modal.conc.id}/reporte`, fd, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Conciliacion_${modal.conc.banco}_${modal.conc.mes}.${formato === 'pdf' ? 'pdf' : 'xlsx'}`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      alert('Error al generar el reporte.');
    } finally {
      setModal(prev => ({ ...prev, descargando: null }));
    }
  };

  useEffect(() => {
    axios.get(`${API}/historial`)
      .then(r => setData(r.data))
      .finally(() => setLoading(false));
  }, []);

  const filtrados = data.filter(r =>
    r.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
    r.banco?.toLowerCase().includes(busqueda.toLowerCase()) ||
    r.mes?.toLowerCase().includes(busqueda.toLowerCase())
  );

  const pct = (cruzan, total) => total > 0 ? Math.round(cruzan / total * 100) : 0;

  const fmt = n => {
    const num = parseFloat(n);
    if (!num) return '-';
    return num.toLocaleString('es-CO', { minimumFractionDigits: 0 });
  };

  // tipo: 'excel' | 'pdf'
  const descargarReporte = async (id, banco, mes, tipo) => {
    const clave = `${id}-${tipo}`;
    setDescargando(clave);
    const ruta = tipo === 'pdf'
      ? `${API}/conciliaciones/${id}/reporte-pdf`
      : `${API}/conciliaciones/${id}/reporte`;
    const ext = tipo === 'pdf' ? 'pdf' : 'xlsx';
    try {
      const r = await axios.get(ruta, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Conciliacion_${banco}_${mes}.${ext}`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      alert('No se puede descargar — los datos de esta conciliación no están disponibles.');
    } finally {
      setDescargando(null);
    }
  };

  return (
    <div style={s.page}>
      <nav style={s.nav}>
        <span style={s.navBrand}>🏦 ConciliaApp</span>
        <div style={s.navRight}>
          <a href="/" style={s.navLink}>← Nueva conciliación</a>
          <span style={s.navUser}>👤 {user?.nombre}</span>
          {user?.rol === 'admin' && <a href="/admin" style={s.navLink}>Admin</a>}
          <a href="/kpis" style={s.navLink}>📊 KPIs</a>
          <a href="/calendario-tributario" style={s.navLink}>📅 Calendario</a>
          <a href="/retencion-fuente" style={s.navLink}>🧾 Retención</a>
          <button onClick={logout} style={s.navBtn}>Salir</button>
        </div>
      </nav>

      <div style={s.content}>
        <div style={s.header}>
          <h2 style={s.title}>📋 Mis conciliaciones</h2>
          <input
            style={s.search}
            placeholder="🔍 Buscar por nombre, banco o mes..."
            value={busqueda}
            onChange={e => setBusqueda(e.target.value)}
          />
        </div>

        {data.length > 0 && (
          <div style={s.stats}>
            {[
              ['Total', data.length, '#3b82f6'],
              ['Este mes', data.filter(r => {
                const d = new Date(r.created_at);
                const now = new Date();
                return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
              }).length, '#8b5cf6'],
              ['Promedio conciliación', `${Math.round(data.reduce((a, r) => a + pct(r.cruzan, r.total_banco), 0) / data.length)}%`, '#16a34a'],
            ].map(([lbl, val, color]) => (
              <div key={lbl} style={s.stat}>
                <div style={{ ...s.statVal, color }}>{val}</div>
                <div style={s.statLbl}>{lbl}</div>
              </div>
            ))}
          </div>
        )}

        {loading ? (
          <div style={s.empty}>⏳ Cargando...</div>
        ) : filtrados.length === 0 ? (
          <div style={s.empty}>
            <div style={{ fontSize: 48 }}>📭</div>
            <p>{busqueda ? 'No se encontraron resultados' : 'Aún no tienes conciliaciones registradas.'}</p>
          </div>
        ) : (
          <div style={s.tableWrap}>
            <table style={s.table}>
              <thead>
                <tr>
                  {['Nombre · Banco · Período', 'Registrada', '% Conciliado', 'Banco / Aux.', 'Pendientes', 'Saldo extracto', 'Saldo libros', 'Acciones'].map(h => (
                    <th key={h} style={s.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtrados.map(r => {
                  const p = pct(r.cruzan, r.total_banco);
                  const fecha = new Date(r.created_at);
                  const fechaStr = `${fecha.getFullYear()}-${String(fecha.getMonth()+1).padStart(2,'0')}-${String(fecha.getDate()).padStart(2,'0')}`;
                  return (
                    <tr key={r.id} style={s.tr}>
                      {/* Columna identidad */}
                      <td style={s.td}>
                        <div style={s.idNombre}>{r.nombre}</div>
                        <div style={s.idSub}>
                          <span style={s.idBanco}>{r.banco || '—'}</span>
                          {r.mes && <span style={s.idMes}>📅 {r.mes}</span>}
                        </div>
                      </td>
                      <td style={{ ...s.td, color: '#888', fontSize: 12 }}>{fechaStr}</td>
                      <td style={s.td}>
                        <div style={s.pctWrap}>
                          <div style={{ ...s.pctBar, width: `${p}%`, background: p >= 90 ? '#16a34a' : p >= 70 ? '#f59e0b' : '#dc2626' }} />
                          <span style={s.pctTxt}>{p}%</span>
                        </div>
                      </td>
                      <td style={{ ...s.td, fontSize: 12, color: '#555' }}>
                        {r.cruzan} <span style={{ color: '#bbb' }}>/</span> {r.total_banco} · {r.total_aux}
                      </td>
                      <td style={{ ...s.td, color: r.no_cruzan_banco + r.no_cruzan_aux > 0 ? '#dc2626' : '#16a34a', fontWeight: 600 }}>
                        {r.no_cruzan_banco + r.no_cruzan_aux}
                      </td>
                      <td style={{ ...s.td, fontSize: 12 }}>{r.saldo_extracto ? `$${fmt(r.saldo_extracto)}` : '-'}</td>
                      <td style={{ ...s.td, fontSize: 12 }}>{r.saldo_libros ? `$${fmt(r.saldo_libros)}` : '-'}</td>
                      <td style={s.td}>
                        <div style={s.acciones}>
                          <button style={{ ...s.btnExcel, opacity: descargando === `${r.id}-excel` ? 0.6 : 1 }}
                            onClick={() => descargarReporte(r.id, r.banco, r.mes, 'excel')}
                            disabled={descargando === `${r.id}-excel`}>
                            {descargando === `${r.id}-excel` ? '⏳' : '📊'}
                          </button>
                          <button style={{ ...s.btnPdf, opacity: descargando === `${r.id}-pdf` ? 0.6 : 1 }}
                            onClick={() => descargarReporte(r.id, r.banco, r.mes, 'pdf')}
                            disabled={descargando === `${r.id}-pdf`}>
                            {descargando === `${r.id}-pdf` ? '⏳' : '📄'}
                          </button>
                          <button style={s.btnCruces} onClick={() => abrirCruces(r)}>
                            ✏️ Editar
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ── Modal cruce manual ── */}
      {modal && (
        <div style={m.overlay}>
          <div style={m.panel}>
            {/* Header */}
            <div style={m.header}>
              <div>
                <div style={m.titulo}>{modal.conc.nombre} · {modal.conc.banco} · {modal.conc.mes}</div>
                <div style={m.subtitulo}>Cruce manual de partidas</div>
              </div>
              <button style={m.btnCerrar} onClick={() => setModal(null)}>✕ Cerrar</button>
            </div>

            {modal.cargando && <div style={m.cargando}>⏳ Cargando datos...</div>}
            {modal.error && <div style={m.error}>{modal.error}</div>}

            {modal.resultado && (
              <>
                {/* Stats */}
                <div style={m.stats}>
                  {[
                    ['Banco', modal.resultado.total_banco, '#3b82f6'],
                    ['Auxiliar', modal.resultado.total_aux, '#8b5cf6'],
                    ['Cruzan ✓', modal.resultado.cruzan, '#16a34a'],
                    ['Sin cruzar ✗', modal.resultado.no_cruzan_banco + modal.resultado.no_cruzan_aux, '#dc2626'],
                  ].map(([lbl, val, color]) => (
                    <div key={lbl} style={m.stat}>
                      <div style={{ ...m.statVal, color }}>{val}</div>
                      <div style={m.statLbl}>{lbl}</div>
                    </div>
                  ))}
                </div>

                {/* Pestañas */}
                <div style={m.tabs}>
                  {[['cruces','✏️ Cruce manual'], ['saldos','💰 Saldos y partidas'], ['repro','🔄 Re-procesar']].map(([k,lbl]) => (
                    <button key={k} style={{ ...m.tab, ...(modal.tab === k ? m.tabActive : {}) }}
                      onClick={() => setModal(prev => ({ ...prev, tab: k }))}>
                      {lbl}
                      {k === 'saldos' && modal.partidas.length > 0 && <span style={m.tabBadge}>{modal.partidas.length}</span>}
                      {k === 'cruces' && modal.cruces.length > 0 && <span style={m.tabBadge}>{modal.cruces.length}</span>}
                    </button>
                  ))}
                </div>

                {/* ── Pestaña: Cruce manual ── */}
                {modal.tab === 'cruces' && (
                  <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <div style={m.instruccion}>
                      {modal.cruces.length > 0 && <span style={m.cruzadosBadge}>{modal.cruces.length} cruce{modal.cruces.length > 1 ? 's' : ''}</span>}
                      {modal.selBanco === null && modal.selAux === null && 'Selecciona banco + aux, o dos ítems del aux para cruzarlos entre sí.'}
                      {modal.selBanco !== null && <span style={{ fontSize: 11, color: '#2563eb', fontWeight: 600 }}>🏦 Banco ✓</span>}
                      {modal.selAux !== null && <span style={{ fontSize: 11, color: '#16a34a', fontWeight: 600 }}>📒 Aux 1 ✓</span>}
                      {modal.selAux2 !== null && <span style={{ fontSize: 11, color: '#15803d', fontWeight: 600 }}>📒 Aux 2 ✓</span>}
                      {modal.selBanco !== null && modal.selAux !== null && (
                        <button style={m.btnCruzar} onClick={cruzarModal}>✅ Cruzar banco ↔ aux</button>
                      )}
                      {modal.selBanco === null && modal.selAux !== null && modal.selAux2 !== null && (
                        <button style={{ ...m.btnCruzar, background: '#7c3aed' }} onClick={cruzarAuxAux}>🔄 Cruzar aux ↔ aux</button>
                      )}
                      {modal.selBanco === null && modal.selAux !== null && modal.selAux2 === null && (
                        <span style={{ fontSize: 11, color: '#7c3aed', fontWeight: 600 }}>Selecciona otro aux para cruzarlos entre sí, o un ítem del banco</span>
                      )}
                    </div>
                    <div style={m.cols}>
                      <div style={m.col}>
                        <div style={m.colTitle}>🏦 Banco — sin cruzar ({modal.resultado.no_cruzan_banco})</div>
                        <div style={m.colScroll}>
                          {(() => {
                            const sHdr = { padding: '2px 7px', fontSize: 10, fontWeight: 700, color: '#fff', background: '#374151', borderRadius: 2, marginTop: 5, display: 'block' };
                            const gastos = {};
                            const consignaciones = [], nds = [];
                            modal.resultado.banco.forEach((r, i) => {
                              if (r._cruza) return;
                              if (r._gasto_bancario) {
                                const det = (r['DETALLE'] || '').toString().toUpperCase();
                                const cat = GASTOS_CATS.find(c => det.includes(c)) || 'GASTO BANCARIO';
                                if (!gastos[cat]) gastos[cat] = { indices: [], total: 0 };
                                gastos[cat].indices.push(i);
                                gastos[cat].total += Math.abs(parseFloat((r['VALOR'] || '0').toString().replace(/[^0-9.-]/g, '')) || 0);
                              } else {
                                const val = parseFloat((r['VALOR'] || '0').toString().replace(/[^0-9.-]/g, '')) || 0;
                                const item = { _origIdx: i, ...r };
                                if (val >= 0) consignaciones.push(item);
                                else nds.push(item);
                              }
                            });
                            const gruposGastos = Object.entries(gastos).map(([cat, g]) => ({
                              _isGroup: true, _groupKey: `grp_${cat}`, _groupIndices: g.indices,
                              _groupCat: cat, _groupTotal: g.total, _groupCount: g.indices.length
                            }));
                            const ndAll = [...nds, ...gruposGastos];
                            if (consignaciones.length === 0 && ndAll.length === 0) return <div style={m.vacio}>Sin ítems pendientes</div>;
                            const renderItem = item => item._isGroup ? (
                              <div key={item._groupKey}
                                style={{ ...m.item, ...(modal.selBanco === item._groupKey ? m.itemSel : {}),
                                  background: modal.selBanco === item._groupKey ? '#fef3c7' : '#fffbeb',
                                  borderLeft: '3px solid #f59e0b' }}
                                onClick={() => setModal(prev => ({ ...prev, selBanco: prev.selBanco === item._groupKey ? null : item._groupKey }))}>
                                <span style={m.itemFecha}>{item._groupCount} cobro{item._groupCount !== 1 ? 's' : ''}</span>
                                <span style={{ ...m.itemValor, color: '#92400e', fontWeight: 700 }}>${item._groupTotal.toLocaleString('es-CO', { minimumFractionDigits: 2 })}</span>
                                <span style={m.itemDesc}>{item._groupCat}</span>
                              </div>
                            ) : (
                              <div key={`b${item._origIdx}`}
                                style={{ ...m.item, ...(modal.selBanco === item._origIdx ? m.itemSel : {}), cursor: 'pointer' }}
                                onClick={() => setModal(prev => ({ ...prev, selBanco: prev.selBanco === item._origIdx ? null : item._origIdx }))}>
                                {modal.selBanco === item._origIdx && <span style={{ fontSize: 10, color: '#2563eb', fontWeight: 700 }}>▶ SELECCIONADO</span>}
                                <span style={m.itemFecha}>{item['FECHA'] || ''}</span>
                                <span style={m.itemValor}>{item['VALOR'] || ''}</span>
                                <span style={m.itemDesc}>{(item['DETALLE'] || '').toString().substring(0, 55)}</span>
                              </div>
                            );
                            return [
                              consignaciones.length > 0 && <span key="sec_c" style={sHdr}>{TIPO_LABELS.consig_no_libros}</span>,
                              ...consignaciones.map(renderItem),
                              ndAll.length > 0 && <span key="sec_nd" style={sHdr}>{TIPO_LABELS.nd_no_libros}</span>,
                              ...ndAll.map(renderItem),
                            ].filter(Boolean);
                          })()}
                        </div>
                      </div>
                      <div style={m.col}>
                        <div style={m.colTitle}>📒 Auxiliar / Partidas — sin cruzar ({modal.resultado.no_cruzan_aux})</div>
                        <div style={m.colScroll}>
                          {(() => {
                            const sHdr = { padding: '2px 7px', fontSize: 10, fontWeight: 700, color: '#fff', background: '#374151', borderRadius: 2, marginTop: 5, display: 'block' };
                            const cfgM = modal.cfg || {};
                            const headers = modal.resultado.headers_aux || [];
                            const renderAux = (r, i) => {
                              const iF = parseInt(cfgM.col_fecha_auxiliar || '1') - 1;
                              const iD = parseInt(cfgM.col_debito_auxiliar || '7') - 1;
                              const iC = parseInt(cfgM.col_credito_auxiliar || '8') - 1;
                              const fecha = (headers[iF] ? (r[headers[iF]] || '') : '').toString().substring(0, 10);
                              const d = headers[iD] ? (r[headers[iD]] || '').toString().trim() : '';
                              const c = headers[iC] ? (r[headers[iC]] || '').toString().trim() : '';
                              const valStr = (d && d !== '0' && d !== '0.0' && !isNaN(parseFloat(d)))
                                ? `D: $${parseFloat(d).toLocaleString('es-CO', { minimumFractionDigits: 0 })}`
                                : (c && c !== '0' && c !== '0.0' && !isNaN(parseFloat(c)))
                                  ? `C: $${parseFloat(c).toLocaleString('es-CO', { minimumFractionDigits: 0 })}`
                                  : '';
                              const skip = new Set([iF, iD, iC]);
                              const desc = headers
                                .map((h, idx) => !skip.has(idx) && h && h !== 'nan' ? (r[h] || '') : null)
                                .filter(v => v && v.toString().trim() && v.toString() !== '0')
                                .slice(0, 2).join(' · ').substring(0, 50);
                              const isSelAux = modal.selAux === i;
                              const isSelAux2 = modal.selAux2 === i;
                              return (
                                <div key={i} style={{ ...m.item,
                                  ...(isSelAux ? m.itemSel : {}),
                                  ...(isSelAux2 ? { background: '#dcfce7', borderLeft: '3px solid #16a34a' } : {}),
                                  cursor: 'pointer' }}
                                  onClick={() => setModal(prev => {
                                    if (prev.selAux === i) return { ...prev, selAux: prev.selAux2 !== null ? prev.selAux2 : null, selAux2: null };
                                    if (prev.selAux2 === i) return { ...prev, selAux2: null };
                                    if (prev.selBanco === null && prev.selAux !== null) return { ...prev, selAux2: i };
                                    return { ...prev, selAux: i, selAux2: null };
                                  })}>
                                  {isSelAux && <span style={{ fontSize: 10, color: '#2563eb', fontWeight: 700 }}>▶ AUX 1</span>}
                                  {isSelAux2 && <span style={{ fontSize: 10, color: '#16a34a', fontWeight: 700 }}>▶ AUX 2</span>}
                                  <span style={m.itemFecha}>{fecha}</span>
                                  <span style={{ ...m.itemValor, color: '#15803d', fontWeight: 600 }}>{valStr}</span>
                                  <span style={m.itemDesc}>{desc}</span>
                                </div>
                              );
                            };
                            const consig = [], cheques = [];
                            modal.resultado.auxiliar.forEach((r, i) => {
                              if (r._cruza) return;
                              if (auxGetCategory(r, headers, cfgM) === 'cheques_pendientes') cheques.push({ r, i });
                              else consig.push({ r, i });
                            });
                            const noPendAux = consig.length === 0 && cheques.length === 0;
                            return [
                              consig.length > 0 && <span key="sec_ce" style={sHdr}>{TIPO_LABELS.consig_no_extracto}</span>,
                              ...consig.map(({ r, i }) => renderAux(r, i)),
                              cheques.length > 0 && <span key="sec_ch" style={sHdr}>{TIPO_LABELS.cheques_pendientes}</span>,
                              ...cheques.map(({ r, i }) => renderAux(r, i)),
                              ...TIPO_ORDER.flatMap(tipo => {
                                const tipoItems = modal.partidas.map((p, origIdx) => ({ p, origIdx })).filter(({ p }) => p.tipo === tipo);
                                if (tipoItems.length === 0) return [];
                                return [
                                  <span key={`shdr_p_${tipo}`} style={{ ...sHdr, background: '#166534', marginTop: 6 }}>{TIPO_LABELS[tipo]} (partida)</span>,
                                  ...tipoItems.map(({ p, origIdx }) => (
                                    <div key={`part_${origIdx}`}
                                      style={{ ...m.item, ...(modal.selAux === `part_${origIdx}` ? m.itemSel : {}),
                                        background: modal.selAux === `part_${origIdx}` ? '#dcfce7' : '#f0fdf4',
                                        borderLeft: '3px solid #16a34a' }}
                                      onClick={() => setModal(prev => ({ ...prev, selAux: prev.selAux === `part_${origIdx}` ? null : `part_${origIdx}` }))}>
                                      <span style={m.itemFecha}>{p.fecha || ''}</span>
                                      <span style={{ ...m.itemValor, color: '#15803d', fontWeight: 700 }}>${Number(p.valor).toLocaleString('es-CO', { minimumFractionDigits: 2 })}</span>
                                      <span style={m.itemDesc}>{p.descripcion}</span>
                                    </div>
                                  ))
                                ];
                              }),
                              noPendAux && modal.partidas.length === 0 && <div key="vacio" style={m.vacio}>Sin ítems pendientes</div>,
                            ].filter(Boolean);
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* ── Pestaña: Saldos y Partidas ── */}
                {modal.tab === 'saldos' && (
                  <div style={m.saldosPanel}>
                    {/* Saldos */}
                    <div style={m.saldosRow}>
                      <div style={m.saldoField}>
                        <label style={m.saldoLabel}>Saldo extracto banco</label>
                        <input style={m.saldoInput} type="number" placeholder="0"
                          value={modal.saldoExtracto}
                          onChange={e => setModal(prev => ({ ...prev, saldoExtracto: e.target.value }))} />
                      </div>
                      <div style={m.saldoField}>
                        <label style={m.saldoLabel}>Saldo según libros</label>
                        <input style={m.saldoInput} type="number" placeholder="0"
                          value={modal.saldoLibros}
                          onChange={e => setModal(prev => ({ ...prev, saldoLibros: e.target.value }))} />
                      </div>
                    </div>

                    {/* Partidas existentes */}
                    <div style={m.partidasTitle}>📝 Partidas manuales ({modal.partidas.length})</div>
                    <div style={m.partidasList}>
                      {modal.partidas.map((p, i) => (
                        <div key={i} style={{ ...m.partidaItem, flexDirection: 'column', alignItems: 'flex-start', gap: 3 }}>
                          <div style={{ display: 'flex', width: '100%', alignItems: 'center', gap: 8 }}>
                            <span style={m.partidaTipo}>{tiposPartida[p.tipo] || p.tipo}</span>
                            <span style={m.partidaDesc}>{p.descripcion}</span>
                            <span style={m.partidaVal}>${Number(p.valor).toLocaleString('es-CO', { minimumFractionDigits: 0 })}</span>
                            <button style={m.btnDelPartida}
                              onClick={() => setModal(prev => ({ ...prev, partidas: prev.partidas.filter((_, j) => j !== i) }))}>✕</button>
                          </div>
                          <textarea
                            style={{ fontSize: 11, width: '100%', resize: 'vertical', border: '1px solid #e5e7eb', borderRadius: 4, padding: '3px 7px', color: '#374151', background: p.observacion ? '#fefce8' : '#f9fafb', minHeight: 28, boxSizing: 'border-box', fontFamily: 'inherit' }}
                            placeholder="Observación / nota (opcional)"
                            value={p.observacion || ''}
                            onChange={e => setModal(prev => ({
                              ...prev,
                              partidas: prev.partidas.map((pp, j) => j === i ? { ...pp, observacion: e.target.value } : pp)
                            }))} />
                        </div>
                      ))}
                      {modal.partidas.length === 0 && <div style={m.vacio}>Sin partidas manuales</div>}
                    </div>

                    {/* Nueva partida */}
                    <div style={m.nuevaPartidaBox}>
                      <div style={m.nuevaPartidaTitle}>+ Agregar partida</div>
                      <div style={m.nuevaPartidaGrid}>
                        <select style={m.saldoInput}
                          value={modal.nuevaPartida.tipo}
                          onChange={e => setModal(prev => ({ ...prev, nuevaPartida: { ...prev.nuevaPartida, tipo: e.target.value } }))}>
                          {Object.entries(tiposPartida).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
                        </select>
                        <input style={m.saldoInput} placeholder="Descripción*"
                          value={modal.nuevaPartida.descripcion}
                          onChange={e => setModal(prev => ({ ...prev, nuevaPartida: { ...prev.nuevaPartida, descripcion: e.target.value } }))} />
                        <input style={m.saldoInput} placeholder="Fecha" value={modal.nuevaPartida.fecha}
                          onChange={e => setModal(prev => ({ ...prev, nuevaPartida: { ...prev.nuevaPartida, fecha: e.target.value } }))} />
                        <input style={m.saldoInput} placeholder="Documento" value={modal.nuevaPartida.documento}
                          onChange={e => setModal(prev => ({ ...prev, nuevaPartida: { ...prev.nuevaPartida, documento: e.target.value } }))} />
                        <input style={m.saldoInput} placeholder="Valor*" type="number" value={modal.nuevaPartida.valor}
                          onChange={e => setModal(prev => ({ ...prev, nuevaPartida: { ...prev.nuevaPartida, valor: e.target.value } }))} />
                        <textarea style={{ ...m.saldoInput, resize: 'vertical', gridColumn: 'span 3', minHeight: 38, fontFamily: 'inherit' }}
                          placeholder="Observación / nota sobre la partida (opcional)"
                          value={modal.nuevaPartida.observacion || ''}
                          onChange={e => setModal(prev => ({ ...prev, nuevaPartida: { ...prev.nuevaPartida, observacion: e.target.value } }))} />
                        <button style={m.btnAgregar} onClick={() => {
                          if (!modal.nuevaPartida.descripcion || !modal.nuevaPartida.valor) return;
                          setModal(prev => ({
                            ...prev,
                            partidas: [...prev.partidas, { ...prev.nuevaPartida, valor: parseFloat(prev.nuevaPartida.valor) }],
                            nuevaPartida: { tipo: 'consig_no_libros', fecha: '', documento: '', descripcion: '', valor: '', observacion: '' }
                          }));
                        }}>+ Agregar</button>
                      </div>
                    </div>
                  </div>
                )}

                {/* ── Pestaña: Re-procesar ── */}
                {modal.tab === 'repro' && (
                  <div style={m.saldosPanel}>
                    <div style={m.reproInfo}>
                      ℹ️ Sube uno o ambos archivos para volver a correr la conciliación con los archivos actualizados. Si no subes un archivo, se usará el que estaba almacenado.
                    </div>
                    <div style={m.reproGrid}>
                      <div>
                        <div style={m.saldoLabel}>🏦 Extracto bancario (xlsx, xls o PDF)</div>
                        <label style={{ ...m.reproZone, ...(modal.nuevoExtracto ? m.reproZoneOk : {}) }}>
                          <input type="file" accept=".xlsx,.xls,.pdf" style={{ display: 'none' }}
                            onChange={e => setModal(prev => ({ ...prev, nuevoExtracto: e.target.files[0] }))} />
                          {modal.nuevoExtracto ? `✅ ${modal.nuevoExtracto.name}` : '📂 Clic para subir extracto'}
                        </label>
                        {modal.nuevoExtracto && (
                          <button style={m.btnQuitarFile} onClick={() => setModal(prev => ({ ...prev, nuevoExtracto: null }))}>✕ Quitar</button>
                        )}
                      </div>
                      <div>
                        <div style={m.saldoLabel}>📒 Auxiliar contable (xlsx, xls)</div>
                        <label style={{ ...m.reproZone, ...(modal.nuevoAuxiliar ? m.reproZoneOk : {}) }}>
                          <input type="file" accept=".xlsx,.xls" style={{ display: 'none' }}
                            onChange={e => setModal(prev => ({ ...prev, nuevoAuxiliar: e.target.files[0] }))} />
                          {modal.nuevoAuxiliar ? `✅ ${modal.nuevoAuxiliar.name}` : '📂 Clic para subir auxiliar'}
                        </label>
                        {modal.nuevoAuxiliar && (
                          <button style={m.btnQuitarFile} onClick={() => setModal(prev => ({ ...prev, nuevoAuxiliar: null }))}>✕ Quitar</button>
                        )}
                      </div>
                    </div>
                    {modal.errorRepro && <div style={m.errorRepro}>{modal.errorRepro}</div>}
                    <button style={m.btnReprocesar} onClick={reprocesar} disabled={modal.reprocesando}>
                      {modal.reprocesando ? '⏳ Reprocesando...' : '⚡ Volver a conciliar'}
                    </button>
                  </div>
                )}

                {/* Descargas */}
                <div style={m.footerBtns}>
                  <button style={{ ...m.btnExcel, background: '#374151', marginRight: 'auto' }}
                    onClick={async () => {
                      try {
                        const fd = new FormData();
                        fd.append('cruces_manuales_json', JSON.stringify(modal.cruces));
                        fd.append('partidas_json', JSON.stringify(modal.partidas));
                        await axios.post(`${API}/conciliaciones/${modal.conc.id}/sync-partidas`, fd);
                        setModal(null);
                      } catch {
                        setModal(null);
                      }
                    }}
                    disabled={!!modal.descargando}>
                    💾 Guardar y cerrar
                  </button>
                  <button style={m.btnExcel} onClick={() => descargarDesdeModal('excel')} disabled={!!modal.descargando}>
                    {modal.descargando === 'excel' ? '⏳ Generando...' : '📊 Descargar Excel'}
                  </button>
                  <button style={m.btnPdf} onClick={() => descargarDesdeModal('pdf')} disabled={!!modal.descargando}>
                    {modal.descargando === 'pdf' ? '⏳ Generando...' : '📄 Descargar PDF'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#f8fafc', fontFamily: 'system-ui,sans-serif' },
  nav: { background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '0 24px', height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  navBrand: { fontWeight: 700, fontSize: 16 },
  navRight: { display: 'flex', alignItems: 'center', gap: 12 },
  navUser: { fontSize: 13, color: '#555' },
  navLink: { fontSize: 13, color: '#2563eb', textDecoration: 'none' },
  navBtn: { padding: '6px 14px', borderRadius: 8, border: '1px solid #e5e7eb', background: 'transparent', cursor: 'pointer', fontSize: 13 },
  content: { padding: '24px', maxWidth: 1400, margin: '0 auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
  title: { fontSize: 20, fontWeight: 700, margin: 0 },
  search: { padding: '10px 16px', borderRadius: 10, border: '1px solid #e5e7eb', fontSize: 14, width: 320, outline: 'none' },
  stats: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 },
  stat: { background: '#fff', borderRadius: 12, padding: '16px', textAlign: 'center', border: '1px solid #e5e7eb' },
  statVal: { fontSize: 28, fontWeight: 700 },
  statLbl: { fontSize: 12, color: '#666', marginTop: 4 },
  empty: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 300, color: '#888', gap: 12, fontSize: 15 },
  tableWrap: { overflowX: 'auto', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { background: '#f8fafc', padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555', borderBottom: '1px solid #e5e7eb', whiteSpace: 'nowrap' },
  tr: { transition: 'background 0.15s' },
  td: { padding: '10px 14px', borderBottom: '1px solid #f0f0f0', whiteSpace: 'nowrap' },
  pctWrap: { position: 'relative', height: 20, background: '#f0f0f0', borderRadius: 10, width: 80, overflow: 'hidden' },
  pctBar: { position: 'absolute', left: 0, top: 0, height: '100%', borderRadius: 10, transition: 'width 0.3s' },
  pctTxt: { position: 'absolute', width: '100%', textAlign: 'center', lineHeight: '20px', fontSize: 11, fontWeight: 600, color: '#fff', mixBlendMode: 'difference' },
  acciones: { display: 'flex', gap: 6 },
  btnExcel: { padding: '6px 10px', borderRadius: 8, background: '#16a34a', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  btnPdf: { padding: '6px 10px', borderRadius: 8, background: '#dc2626', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  btnCruces: { padding: '6px 12px', borderRadius: 8, background: '#2563eb', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 },
  idNombre: { fontWeight: 700, fontSize: 14, color: '#111', marginBottom: 3 },
  idSub: { display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' },
  idBanco: { fontSize: 12, color: '#2563eb', fontWeight: 600 },
  idMes: { fontSize: 12, color: '#555', background: '#f0f9ff', borderRadius: 20, padding: '1px 8px', border: '1px solid #bae6fd' },
};

const m = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1000, display: 'flex', alignItems: 'stretch', justifyContent: 'stretch' },
  panel: { background: '#fff', borderRadius: 0, width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '18px 24px', borderBottom: '1px solid #e5e7eb' },
  titulo: { fontSize: 16, fontWeight: 700, color: '#111' },
  subtitulo: { fontSize: 12, color: '#888', marginTop: 2 },
  btnCerrar: { padding: '6px 14px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#f8fafc', cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap' },
  cargando: { padding: 40, textAlign: 'center', color: '#888', fontSize: 15 },
  error: { padding: 20, color: '#dc2626', fontSize: 13 },
  stats: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, padding: '16px 24px', borderBottom: '1px solid #f0f0f0' },
  stat: { background: '#f8fafc', borderRadius: 10, padding: '10px', textAlign: 'center' },
  statVal: { fontSize: 22, fontWeight: 700 },
  statLbl: { fontSize: 11, color: '#666', marginTop: 2 },
  instruccion: { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 24px', fontSize: 13, color: '#555', background: '#f8fafc', borderBottom: '1px solid #e5e7eb', flexWrap: 'wrap' },
  cruzadosBadge: { background: '#dcfce7', color: '#16a34a', borderRadius: 20, padding: '2px 10px', fontSize: 12, fontWeight: 600 },
  btnCruzar: { padding: '6px 16px', borderRadius: 8, background: '#16a34a', color: '#fff', border: 'none', fontWeight: 600, fontSize: 13, cursor: 'pointer', marginLeft: 'auto' },
  cols: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0, flex: 1, overflow: 'hidden', borderBottom: '1px solid #e5e7eb' },
  col: { display: 'flex', flexDirection: 'column', overflow: 'hidden', borderRight: '1px solid #e5e7eb' },
  colTitle: { padding: '8px 14px', fontSize: 12, fontWeight: 600, color: '#555', background: '#f8fafc', borderBottom: '1px solid #e5e7eb', flexShrink: 0 },
  colScroll: { overflowY: 'auto', flex: 1 },
  item: { padding: '8px 14px', borderBottom: '1px solid #f5f5f5', cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 2 },
  itemSel: { background: '#eff6ff', borderLeft: '3px solid #2563eb' },
  itemFecha: { fontSize: 10, color: '#888' },
  itemValor: { fontSize: 13, fontWeight: 700, color: '#1e40af' },
  itemDesc: { fontSize: 12, color: '#333' },
  vacio: { padding: 20, textAlign: 'center', color: '#aaa', fontSize: 12 },
  footerBtns: { display: 'flex', gap: 10, padding: '14px 24px', justifyContent: 'flex-end', alignItems: 'center', borderTop: '1px solid #e5e7eb', flexShrink: 0 },
  btnExcel: { padding: '9px 20px', borderRadius: 9, background: '#16a34a', color: '#fff', border: 'none', fontWeight: 600, fontSize: 14, cursor: 'pointer' },
  btnPdf: { padding: '9px 20px', borderRadius: 9, background: '#dc2626', color: '#fff', border: 'none', fontWeight: 600, fontSize: 14, cursor: 'pointer' },
  tabs: { display: 'flex', borderBottom: '1px solid #e5e7eb', flexShrink: 0 },
  tab: { padding: '10px 20px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, color: '#666', borderBottom: '2px solid transparent', marginBottom: -1, display: 'flex', alignItems: 'center', gap: 6 },
  tabActive: { color: '#2563eb', borderBottomColor: '#2563eb', fontWeight: 600 },
  tabBadge: { background: '#dbeafe', color: '#2563eb', borderRadius: 20, padding: '1px 7px', fontSize: 11, fontWeight: 700 },
  saldosPanel: { flex: 1, overflowY: 'auto', padding: '16px 24px', display: 'flex', flexDirection: 'column', gap: 16 },
  saldosRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  saldoField: { display: 'flex', flexDirection: 'column', gap: 4 },
  saldoLabel: { fontSize: 12, color: '#666', fontWeight: 500 },
  saldoInput: { padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 13, width: '100%', boxSizing: 'border-box' },
  partidasTitle: { fontSize: 13, fontWeight: 600, color: '#333' },
  partidasList: { border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden' },
  partidaItem: { display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px', borderBottom: '1px solid #f0f0f0', fontSize: 12 },
  partidaTipo: { fontSize: 10, color: '#2563eb', fontWeight: 600, whiteSpace: 'nowrap' },
  partidaDesc: { flex: 1, color: '#333' },
  partidaVal: { fontWeight: 700, color: '#16a34a', whiteSpace: 'nowrap' },
  btnDelPartida: { background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 14, padding: '0 2px' },
  nuevaPartidaBox: { background: '#f8fafc', borderRadius: 10, padding: '12px', border: '1px solid #e5e7eb' },
  nuevaPartidaTitle: { fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8 },
  nuevaPartidaGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 },
  btnAgregar: { padding: '8px', borderRadius: 8, background: '#2563eb', color: '#fff', border: 'none', fontWeight: 600, cursor: 'pointer', fontSize: 13, gridColumn: 'span 3' },
  reproInfo: { fontSize: 12, color: '#555', background: '#f0f9ff', padding: '10px 14px', borderRadius: 8, border: '1px solid #bae6fd', lineHeight: 1.5 },
  reproGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
  reproZone: { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 14px', border: '2px dashed #d1d5db', borderRadius: 10, cursor: 'pointer', fontSize: 13, color: '#666', background: '#fafafa', marginTop: 6, textAlign: 'center' },
  reproZoneOk: { borderColor: '#16a34a', background: '#f0fdf4', color: '#16a34a', borderStyle: 'solid' },
  btnQuitarFile: { marginTop: 4, fontSize: 11, color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer', padding: 0 },
  errorRepro: { color: '#dc2626', fontSize: 13, padding: '8px 12px', background: '#fef2f2', borderRadius: 8, border: '1px solid #fecaca' },
  btnReprocesar: { padding: '12px', borderRadius: 10, background: '#2563eb', color: '#fff', border: 'none', fontWeight: 700, fontSize: 15, cursor: 'pointer', width: '100%' },
};
